import { isDefined } from '../../../utils/utils';

export type TaxStatus =
  | 'AMT'
  | 'Tax'
  | 'T-E'
  | 'Corp Tax'
  | 'Other'
  | 'Various'
  | '';

const Priority: TaxStatus[] = [
  'AMT',
  'Tax',
  'T-E',
  'Corp Tax',
  'Other',
  'Various',
  ''
];

export function taxStatusComparator(
  valA: TaxStatus[],
  valB: TaxStatus[],
  _nodeA,
  _nodeB,
  isInverted?: boolean
): number {
  // Handle null or undefined values
  if (!isDefined(valA) || !isDefined(valB)) {
    return 0;
  }

  if (valA.length > 1 && valB.length > 1) {
    return 0;
  }

  if (valA.length > 1) {
    return isInverted ? -1 : 1;
  } else if (valB.length > 1) {
    return isInverted ? 1 : -1;
  }

  return Priority.indexOf(valA[0]) - Priority.indexOf(valB[0]);
}
